/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 *
 * @export
 * @interface Contract
 */
export interface Contract {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   * The unique_id of an organisation
   */
  organisation: string;
  /**
   *
   */
  readonly organisationName?: string;
  /**
   * A space-separated list of scopes (options: basic simulate create lizardrain lizardprocess manageusers managecontracts test livesite waterquality)
   */
  readonly scope?: string;
  /**
   *
   */
  startDate?: Date | null;
  /**
   *
   */
  hoursBought: number;
  /**
   *
   */
  readonly hoursUsed?: number;
  /**
   *
   */
  sessionLimit: number;
  /**
   *
   */
  readonly currentSessions?: number;
  /**
   * Maximum amount of ThreediModels per Organisation
   */
  threedimodelLimit?: number;
  /**
   * The unique_id of an organisation
   */
  createdBy?: string;
  /**
   *
   */
  lizardPostProcessingOrganisationUniqueId?: string | null;
}

/**
 * Check if a given object implements the Contract interface.
 */
export function instanceOfContract(value: object): value is Contract {
  if (!("organisation" in value) || value["organisation"] === undefined) return false;
  if (
    (!("hoursBought" in (value as Record<string, any>)) &&
      !("hours_bought" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["hoursBought"] === undefined &&
      (value as Record<string, any>)["hours_bought"] === undefined)
  )
    return false;
  if (
    (!("sessionLimit" in (value as Record<string, any>)) &&
      !("session_limit" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["sessionLimit"] === undefined &&
      (value as Record<string, any>)["session_limit"] === undefined)
  )
    return false;
  return true;
}

export function ContractFromJSON(json: any): Contract {
  return ContractFromJSONTyped(json, false);
}

export function ContractFromJSONTyped(json: any, ignoreDiscriminator: boolean): Contract {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    id: json["id"] == null ? undefined : json["id"],
    organisation: json["organisation"],
    organisationName: json["organisation_name"] == null ? undefined : json["organisation_name"],
    scope: json["scope"] == null ? undefined : json["scope"],
    startDate:
      json["start_date"] === undefined
        ? undefined
        : json["start_date"] === null
        ? null
        : parseDate(json["start_date"]),
    hoursBought: json["hours_bought"],
    hoursUsed: json["hours_used"] == null ? undefined : json["hours_used"],
    sessionLimit: json["session_limit"],
    currentSessions: json["current_sessions"] == null ? undefined : json["current_sessions"],
    threedimodelLimit: json["threedimodel_limit"] == null ? undefined : json["threedimodel_limit"],
    createdBy: json["created_by"] == null ? undefined : json["created_by"],
    lizardPostProcessingOrganisationUniqueId:
      json["lizard_post_processing_organisation_unique_id"] === undefined
        ? undefined
        : json["lizard_post_processing_organisation_unique_id"] === null
        ? null
        : json["lizard_post_processing_organisation_unique_id"],
  };
}

export function ContractToJSON(json: any): Contract {
  return ContractToJSONTyped(json, false);
}

export function ContractToJSONTyped(
  value?: Omit<
    Contract,
    "url" | "id" | "organisationName" | "scope" | "hoursUsed" | "currentSessions"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    organisation: value["organisation"],
    start_date: value["startDate"] == null ? value["startDate"] : serializeDate(value["startDate"]),
    hours_bought: value["hoursBought"],
    session_limit: value["sessionLimit"],
    threedimodel_limit: value["threedimodelLimit"],
    created_by: value["createdBy"],
    lizard_post_processing_organisation_unique_id:
      value["lizardPostProcessingOrganisationUniqueId"],
  };
}
